type InlineEditPost = {
	edit: (postID: number, ...args: unknown[]) => void;
	getId: (t: HTMLTableRowElement) => string;
	init: () => void;
	revert: () => void;
	save: (n: HTMLTableRowElement) => false;
	setBulk: () => void;
	toggle: (t: HTMLTableRowElement) => void;
	type: "page" | "post";
	what: "#post-";
};

declare const inlineEditPost: InlineEditPost | undefined;

/** Initializes the meta-fields for quick edit. */
export default function (): void {
	if (typeof inlineEditPost === "undefined" || !inlineEditPost) return;
	const inlineEditFunction = inlineEditPost.edit;

	inlineEditPost.edit = function (postID: number, ...rest) {
		// let's merge arguments of the original function

		inlineEditFunction.apply(this, [postID, ...rest]);

		// get the post ID from the argument
		if (typeof postID === "object") {
			// if it is object, get the ID number
			postID = parseInt(this.getId(postID));
		}

		const postRow = document.getElementById("post-" + postID);
		if (postRow) {
			const metaFields = postRow.querySelectorAll<HTMLSpanElement>(
				".rt-post-meta-field",
			);
			for (const field of metaFields) {
				const metaValue = field.dataset.value;
				const selectID = field.dataset.selectId;
				if (!selectID) {
					continue;
				}
				const select = document.getElementById(selectID) as HTMLSelectElement;
				if (!metaValue || !select) return;
				select.value = metaValue;
			}
		}
	};
}
